import { CakeSlice } from "lucide-react";
import { orderMessage, whatsappLink } from "@/constants";
import { WhatsAppIcon } from "@/components/icons";

export const DoceCard = ({ doce }) => (
  <article
    data-testid={`sweet-card-${doce.id}`}
    className="group bg-white rounded-3xl border border-sand overflow-hidden shadow-[0_14px_35px_-18px_rgba(61,35,20,0.25)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_22px_45px_-18px_rgba(61,35,20,0.3)]"
  >
    <div className="aspect-square overflow-hidden">
      {doce.image ? (
        <img
          src={doce.image}
          alt={doce.alt}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      ) : (
        <div
          role="img"
          aria-label={`Fotografia de ${doce.name} disponível em breve`}
          className="w-full h-full bg-beige flex flex-col items-center justify-center gap-3"
        >
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white border border-sand shadow-sm">
            <CakeSlice className="w-7 h-7 text-caramel" aria-hidden="true" />
          </span>
          <span className="font-hand text-xl text-cocoa">Fotografia em breve</span>
        </div>
      )}
    </div>
    <div className="p-6">
      <h3 className="font-serif text-xl font-semibold text-chocolate">{doce.name}</h3>
      <p className="mt-2 text-sm leading-relaxed text-cocoa">{doce.description}</p>
      <a
        href={whatsappLink(orderMessage(doce.name))}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`sweet-card-order-btn-${doce.id}`}
        className="mt-4 inline-flex items-center gap-2 rounded-full border border-caramel px-4 py-2 text-sm font-medium text-caramel transition-colors duration-200 hover:bg-caramel hover:text-cream"
      >
        <WhatsAppIcon className="w-4 h-4" />
        Pedir este doce
      </a>
    </div>
  </article>
);
